@if (formGroup) {
  <form [formGroup]="formGroup" class="w-100">
    <create-demand-form-entry
      [hideInputGroupElements]="true"
      [saveSpaceForErrorMsg]="false"
      [control]="formGroup.controls.unitPrice"
      [label]="'Stückpreis' | translate"
      >
      <div class="col">
        <div class="row align-items-center">
          <div class="col-auto mb-1">
            <iim-decimal-input-v2 formControlName="unitPrice" [emitOnType]="true"></iim-decimal-input-v2>
          </div>
          <div class="col pe-0">
            @if (activeCurrencies) {
              <iim-advanced-autocomplete formControlName="currency" [showLabel]="false">
                @for (currency of selectableCurrencies; track currency) {
                  <iim-autocomplete-option [value]="currency">
                    {{ currency.valueDisplay }}
                  </iim-autocomplete-option>
                }
              </iim-advanced-autocomplete>
            }
          </div>
        </div>
        @if (noCurrencySelectable) {
          <!-- Every active currency is excluded (empty customer-supplier intersection). This blocks
               deliberately (EPROC-11425, decision 06.08.2026) — name the dead end and the way out. -->
          <div class="row mt-1">
            <small class="col-auto text-muted">
              <em class="fas fa-triangle-exclamation pe-1"></em>
              {{
                'Keine Währung wählbar: Der Mandant und die gewählten Lieferanten haben keine gemeinsame Währung. Wählen Sie andere Lieferanten oder lassen Sie die Währungs-Stammdaten erweitern.'
                  | translate
              }}
            </small>
          </div>
        }
        @if (activeCurrencies && (customerExcludedCurrencyNames || supplierExcludedCurrencyNames)) {
          <div class="row mt-1">
            @if (customerExcludedCurrencyNames) {
              <small class="col-auto text-muted">
                <em class="fas fa-circle-info pe-1"></em>
                {{
                  'Vom Mandanten nicht zugelassen: \{\{currencies\}\}'
                    | translate: { currencies: customerExcludedCurrencyNames }
                }}
                @if (customerExcludedOverflow) {
                  {{ 'und \{\{count\}\} weitere' | translate: { count: customerExcludedOverflow } }}
                }
              </small>
            }
            @if (supplierExcludedCurrencyNames) {
              <small class="col-auto text-muted">
                <em class="fas fa-circle-info pe-1"></em>
                {{
                  'Nicht von allen Lieferanten akzeptiert: \{\{currencies\}\}'
                    | translate: { currencies: supplierExcludedCurrencyNames }
                }}
                @if (supplierExcludedOverflow) {
                  {{ 'und \{\{count\}\} weitere' | translate: { count: supplierExcludedOverflow } }}
                }
              </small>
            }
          </div>
        }
      </div>
    </create-demand-form-entry>
    <separator></separator>
    <create-demand-form-entry
      [hideInputGroupElements]="true"
      [control]="formGroup.controls.taxPercent"
      [label]="'Steuer' | translate"
      >
      <div class="col">
        <div class="row align-items-center">
          <div class="col-auto">
            <iim-decimal-input-v2 formControlName="taxPercent"></iim-decimal-input-v2>
          </div>
          <div class="col-auto px-0">
            <span class="mt-2 px-2"><em class="fas fa-percent fa-1_5x"></em></span>
          </div>
        </div>
      </div>
    </create-demand-form-entry>
  </form>
}
